import ChatContainer from './components/ChatContainer'
import MessageList from './components/MessageList'
import ChatInput from './components/ChatInput'
import type { MessageListProps } from './components/MessageList'
import type { ChatContainerProps } from './components/ChatContainer'
import type { ChatInputProps } from './components/ChatInput'
import type { ReactNode, Ref } from 'react'
import type { ScrollBarRef } from './types'

export type MessageList = MessageListProps['list']

export type ChatBoxProps = {
    messageList: MessageList
    header?: ChatContainerProps['header']
    showMessageList?: boolean
    children?: ReactNode
    containerClass?: string
    /** Small print under the input, e.g. a reliability notice. */
    inputFootnote?: ReactNode
    ref?: Ref<ScrollBarRef>
} & Omit<MessageListProps, 'list'> &
    ChatInputProps

const ChatBox = (props: ChatBoxProps) => {
    const {
        messageList,
        showMessageList = true,
        children,
        header,
        placeholder,
        onInputChange,
        customRenderer,
        customAction,
        bubbleClass,
        typing,
        messageListClass,
        containerClass,
        inputFootnote,
        onScroll,
        ref,
    } = props

    return (
        <ChatContainer
            className={containerClass}
            header={header}
            input={
                <div>
                    <ChatInput
                        placeholder={placeholder}
                        onInputChange={onInputChange}
                    />
                    {inputFootnote != null && (
                        <p className="px-3 pt-1.5 text-center text-[11px] leading-4 text-[var(--rda-muted)] [text-wrap:balance]">
                            {inputFootnote}
                        </p>
                    )}
                </div>
            }
        >
            {showMessageList && (
                <MessageList
                    ref={ref}
                    list={messageList}
                    customRenderer={customRenderer}
                    customAction={customAction}
                    typing={typing}
                    messageListClass={messageListClass}
                    bubbleClass={bubbleClass}
                    onScroll={onScroll}
                />
            )}
            {children}
        </ChatContainer>
    )
}

export default ChatBox
